import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Close flyout when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    // Close flyout when ESC key is pressed
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    
    // Find the menu element
    this.menuElement = this.element.querySelector('.absolute');
    
    // Initialize in hidden state
    if (this.menuElement) {
      this.menuElement.classList.add('hidden');
      this.menuElement.setAttribute('aria-hidden', 'true');
    }
    
    // Check if this is in mobile menu
    this.isMobile = this.element.closest('#mobile-menu') !== null;
  }
  
  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }
  
  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.menuElement) {
      const isHidden = this.menuElement.classList.contains('hidden');
      
      if (isHidden) {
        this.show();
      } else {
        this.hide();
      }
    }
  }
  
  show() {
    if (!this.menuElement) return;
    
    // Remove hidden class
    this.menuElement.classList.remove('hidden');
    
    // Add entrance animation classes
    this.menuElement.classList.add('transition', 'ease-out', 'duration-200');
    
    if (this.isMobile) {
      // For mobile, display as a dropdown rather than a centered flyout
      this.menuElement.classList.add('relative', 'left-0', 'ml-4', 'w-auto', 'opacity-100');
      this.menuElement.classList.remove('-translate-x-1/2');
    } else {
      // Desktop behavior
      this.menuElement.classList.add('opacity-100', 'translate-y-0');
      this.menuElement.classList.remove('opacity-0', 'translate-y-1');
    }
    
    // Update ARIA attributes
    this.menuElement.setAttribute('aria-hidden', 'false');
    this.element.querySelector('button').setAttribute('aria-expanded', 'true');
  }
  
  hide() {
    if (!this.menuElement) return;
    
    // Add exit animation classes
    this.menuElement.classList.add('transition', 'ease-in', 'duration-150');
    
    if (!this.isMobile) {
      // Only add these classes for desktop version
      this.menuElement.classList.add('opacity-0', 'translate-y-1');
      this.menuElement.classList.remove('opacity-100', 'translate-y-0');
    }
    
    // Hide after animation completes
    setTimeout(() => {
      this.menuElement.classList.add('hidden');
      
      // Update ARIA attributes
      this.menuElement.setAttribute('aria-hidden', 'true');
      this.element.querySelector('button').setAttribute('aria-expanded', 'false');
    }, 150);
  }
  
  handleOutsideClick(event) {
    if (!this.element.contains(event.target) && !this.menuElement.classList.contains('hidden')) {
      this.hide();
    }
  }
  
  handleKeyDown(event) {
    if (event.key === 'Escape' && !this.menuElement.classList.contains('hidden')) {
      this.hide();
    }
  }
} 